import { z } from 'zod';
import { CINEMATIC_IDS } from '../data/cinematics.js';
/**
 * Server → the one player it is for (ADR 0067): play this scene of Shefira,
 * input held for its length. Sent when a quest that shows her is turned in,
 * or when a game master replays one (`admin_command` `play_cinematic`).
 */
export const CinematicEventSchema = z.object({ id: z.enum(CINEMATIC_IDS) }).strict();
//# sourceMappingURL=cinematic.js.map